var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolomonIslands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#214fb5",
    d: "M30 0H0v24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e5a34",
    d: "M30 0 0 24h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6d44a",
    d: "M0 22.75V24h1.5L30 1.25V0h-1.48z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.17 6.9 7.8 5.79 7.43 6.9h-1.2l.97.7-.37 1.13.97-.7.96.7-.37-1.13.97-.7zm2.27-2.07-.37 1.14.97-.7.96.7-.37-1.14.97-.7h-1.2L11.04 3l-.37 1.13h-1.2zm.96 4.85-.36-1.13-.37 1.13h-1.2l.97.7-.37 1.14.97-.7.96.7-.37-1.13.97-.7zm-6.47 0-.37-1.13-.37 1.13H3l.96.7-.36 1.14.96-.7.96.7-.36-1.13.96-.7zM4.56 3l-.37 1.13H3l.96.7-.36 1.14.96-.7.96.7-.36-1.14.96-.7h-1.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolomonIslands);
export default __webpack_public_path__ + "static/media/solomon-islands.e8dcdf7426887d6717c0a08f180f5e71.svg";
export { ForwardRef as ReactComponent };